// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getMediaGroupsListFailed, getMediaGroupsListRequested, getMediaGroupsListSucceeded } from './select-media-group.actions';
import { MediaGroupService } from '@par/app/shared/select-media-group/services/media-group.service';
import { Store } from '@ngrx/store';
import { selectMediaGroupsListRawResponse } from './select-media-group.selectors';

@Injectable()
export class SelectMediaGroupEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getMediaGroupsListRequested),
      withLatestFrom(this.store.select(selectMediaGroupsListRawResponse)),
      filter(([, response]) => response == null),
      exhaustMap(() => this.service.getGroups()
        .pipe(
          map((response) => getMediaGroupsListSucceeded({response: response.groups})),
          catchError(() => of(getMediaGroupsListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: MediaGroupService,
    private store: Store,
  ) {
  }
}
